/** Adapted from standalone-search f83fe2d1 via selected Registrar V2. See docs/delivery/iteration2/fusion-shared-kit/TRANSFER.json. */
import * as React from "react";

interface VisuallyHiddenProps {
  children: React.ReactNode;
  asChild?: boolean;
}

export function VisuallyHidden({
  children,
  asChild = false,
}: VisuallyHiddenProps) {
  const styles: React.CSSProperties = {
    position: "absolute",
    width: "1px",
    height: "1px",
    padding: "0",
    margin: "-1px",
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    whiteSpace: "nowrap",
    border: "0",
  };

  if (
    asChild &&
    React.isValidElement<{ style?: React.CSSProperties }>(children)
  ) {
    return React.cloneElement(children, {
      ...children.props,
      style: { ...styles, ...children.props.style },
    });
  }

  return <span style={styles}>{children}</span>;
}
